export const API_URL = 'https://chromiecraft.com/api';
export const SERVER_NAME = 'ChromieCraft';
